const paymentResponse = {
    Unknown: 0,
    Approved: 1,
    Retry: 2,
    Declined: 3
}

export default paymentResponse